import { render, staticRenderFns } from "./showv2.vue?vue&type=template&id=4b9afc00"
import script from "./showv2.vue?vue&type=script&lang=js"
export * from "./showv2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports